(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amare-bed-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CODES = {
      shape: { s: 'straight', w: 'wingback', k: 'sleigh', c: 'curved', t: 'tv', r: 'round' },
      finish: { p: 'plain', b: 'chesterfield', l: 'lined', n: 'panelled' },
      height: { 1: 'low', 2: 'standard', 3: 'high' }
    };
    var LABELS = {
      shape: { straight: 'Straight', wingback: 'Wingback', sleigh: 'Sleigh', curved: 'Curved', tv: 'TV bed', round: 'Round' },
      finish: { plain: 'Plain', chesterfield: 'Chesterfield', lined: 'Lined', panelled: 'Panelled' },
      height: { low: 'Low headboard', standard: 'Standard height', high: 'Tall headboard' }
    };
    var GROUPS = ['shape', 'finish', 'height'];

    function norm(v) {
      return String(v || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9£]+/g, ' ').trim();
    }
    function has(text, re) { return re.test(' ' + text + ' '); }

    /* Fallback for beds not in the map: read the title */
    function guess(title) {
      var t = norm(title);
      if (has(t, /(£150|\bbase\b|guest bed|captain bed|wall panel headboard)/)) return null;
      var shape = has(t, /\bwing/) ? 'wingback' : has(t, /\bsleigh\b/) ? 'sleigh' : has(t, /\btv\b/) ? 'tv' : has(t, /\bround\b/) ? 'round' : has(t, /\b(cloud|curved|moon|arch|arched|crescent|wave)\b/) ? 'curved' : 'straight';
      var finish = has(t, /\b(chesterfield|button|buttoned|studded)\b/) ? 'chesterfield' : has(t, /\b(lined|linear|channel|channelled|fluted|tubes)\b/) ? 'lined' : has(t, /\b(panel|panelled|cubed|cubic|cube)\b/) ? 'panelled' : 'plain';
      var height = has(t, /\blow\b/) ? 'low' : has(t, /\b(high|tall|statement|ambassador)\b/) ? 'high' : 'standard';
      return { shape: shape, finish: finish, height: height };
    }

    function decode(code) {
      if (!code || code === 'x') return null;
      return { shape: CODES.shape[code[0]], finish: CODES.finish[code[1]], height: CODES.height[code[2]] };
    }

    /* Corrections box: handle=shape, finish, height  or  handle=hide */
    function parseFixes(text) {
      var out = {};
      String(text || '').split(/\n+/).forEach(function (line) {
        var i = line.indexOf('=');
        if (i < 1) return;
        var handle = line.slice(0, i).trim().toLowerCase().replace(/^.*\/products\//, '').replace(/[?#].*$/, '');
        var words = norm(line.slice(i + 1)).split(' ');
        if (words.indexOf('hide') > -1) { out[handle] = 'hide'; return; }
        var fix = {};
        words.forEach(function (w) {
          if (w === 'curve' || w === 'cloud') w = 'curved';
          if (w === 'wing' || w === 'winged') w = 'wingback';
          if (w === 'buttoned' || w === 'button') w = 'chesterfield';
          if (w === 'panel' || w === 'cubed') w = 'panelled';
          if (w === 'tall') w = 'high';
          GROUPS.forEach(function (g) { if (LABELS[g][w]) fix[g] = w; });
        });
        out[handle] = fix;
      });
      return out;
    }

    function initFinder(root) {
      if (!root || root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      var sid = root.id.replace('al-finder-', '');
      var read = function (id, fallback) {
        var node = document.getElementById(id + sid);
        try { return node ? JSON.parse(node.textContent) : fallback; } catch (e) { return fallback; }
      };
      var raw = read('al-finder-products-', []);
      var map = read('al-finder-map-', {});
      var fixes = parseFixes(read('al-finder-fix-', ''));

      var seen = {};
      var products = [];
      raw.forEach(function (p) {
        if (seen[p.handle]) return;
        seen[p.handle] = true;
        var fix = fixes[p.handle];
        if (fix === 'hide') return;
        var attrs = map.hasOwnProperty(p.handle) ? decode(map[p.handle]) : guess(p.title);
        if (!attrs) return;
        if (fix) GROUPS.forEach(function (g) { if (fix[g]) attrs[g] = fix[g]; });
        p.attrs = attrs;
        products.push(p);
      });

      var steps = GROUPS;
      var current = 0;
      var mode = 'best';
      var pageSize = Math.max(4, parseInt(root.dataset.initialLimit || '12', 10));
      var limit = pageSize;
      var state = { shape: [], finish: [], height: [] };
      var exact = [];
      var similar = [];

      var $ = function (s) { return root.querySelector(s); };
      var progress = $('[data-progress]');
      var tabs = root.querySelectorAll('[data-goto]');
      var nav = $('[data-navigation]');
      var back = $('[data-back]');
      var next = $('[data-next]');
      var nextLabel = $('[data-next-label]');
      var live = $('[data-live-count]');
      var skip = $('[data-skip]');
      var grid = $('[data-grid]');
      var empty = $('[data-empty]');
      var more = $('[data-load-more]');

      function fits(p, except) {
        return GROUPS.every(function (g) {
          return g === except || !state[g].length || state[g].indexOf(p.attrs[g]) > -1;
        });
      }
      function score(p) {
        return GROUPS.reduce(function (n, g) { return n + (state[g].length && state[g].indexOf(p.attrs[g]) > -1 ? 1 : 0); }, 0);
      }

      /* Show only options that have beds, given the other answers, with live counts */
      function refreshOptions(group) {
        var box = root.querySelector('[data-group="' + group + '"]');
        var visible = 0;
        box.querySelectorAll('[data-value]').forEach(function (btn) {
          var v = btn.dataset.value;
          var n = products.filter(function (p) { return p.attrs[group] === v && fits(p, group); }).length;
          var on = state[group].indexOf(v) > -1;
          btn.querySelector('[data-count]').textContent = n + (n === 1 ? ' bed' : ' beds');
          btn.hidden = n === 0 && !on;
          if (!btn.hidden) visible++;
        });
        box.style.setProperty('--al-cols', Math.min(visible, group === 'height' ? 3 : (visible > 4 ? 3 : visible)) || 1);
      }

      function count() { return products.filter(function (p) { return fits(p); }).length; }
      function updateLive() {
        var n = count();
        live.textContent = n + (n === 1 ? ' bed' : ' beds');
      }

      function setSelected(group, value, on) {
        var b = root.querySelector('[data-group="' + group + '"] [data-value="' + value + '"]');
        if (b) { b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', String(on)); }
      }

      function updateTabs(active) {
        tabs.forEach(function (tab, i) {
          tab.classList.toggle('is-current', i === active);
          tab.classList.toggle('is-done', i !== active && state[steps[i]].length > 0);
          if (i === active) tab.setAttribute('aria-current', 'step'); else tab.removeAttribute('aria-current');
        });
      }

      function showStep(i) {
        current = Math.max(0, Math.min(i, steps.length - 1));
        root.querySelectorAll('[data-stage]').forEach(function (s) { s.hidden = true; });
        root.querySelector('[data-stage="' + steps[current] + '"]').hidden = false;
        progress.style.width = ((current + 1) / (steps.length + 1) * 100) + '%';
        back.hidden = current === 0;
        nav.hidden = false;
        nextLabel.textContent = current === steps.length - 1 ? 'See beds' : 'Next';
        skip.textContent = 'Any ' + steps[current];
        refreshOptions(steps[current]);
        updateTabs(current);
        updateLive();
      }

      function card(p) {
        var a = document.createElement('a');
        a.className = 'al-finder__card';
        a.href = p.url;
        var media = document.createElement('div');
        media.className = 'al-finder__card-media';
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image; img.alt = p.imageAlt || p.title; img.loading = 'lazy'; img.width = 720; img.height = 720;
          media.appendChild(img);
        }
        var body = document.createElement('div');
        body.className = 'al-finder__card-body';
        var title = document.createElement('p');
        title.className = 'al-finder__card-title';
        title.textContent = p.title.split(' | ')[0];
        var meta = document.createElement('p');
        meta.className = 'al-finder__card-meta';
        meta.textContent = [LABELS.shape[p.attrs.shape], LABELS.finish[p.attrs.finish], LABELS.height[p.attrs.height]].join(' · ');
        var row = document.createElement('div');
        row.className = 'al-finder__price-row';
        var price = document.createElement('span');
        price.className = 'al-finder__price';
        price.textContent = 'From ' + p.price;
        row.appendChild(price);
        if (p.comparePrice) {
          var c = document.createElement('span');
          c.className = 'al-finder__compare'; c.textContent = p.comparePrice; row.appendChild(c);
        }
        body.appendChild(title); body.appendChild(meta); body.appendChild(row);
        a.appendChild(media); a.appendChild(body);
        return a;
      }

      function render() {
        var list = mode === 'best' ? exact : similar;
        grid.replaceChildren();
        list.slice(0, limit).forEach(function (p) { grid.appendChild(card(p)); });
        empty.hidden = list.length > 0;
        grid.hidden = list.length === 0;
        more.hidden = list.length <= limit;
        $('[data-best-count]').textContent = exact.length;
        $('[data-all-count]').textContent = similar.length;
        root.querySelectorAll('[data-result-mode]').forEach(function (b) {
          var on = b.dataset.resultMode === mode;
          b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on));
        });
        var picked = GROUPS.some(function (g) { return state[g].length; });
        $('[data-results-heading]').textContent = !picked ? 'All our beds' : exact.length ? 'Your matches' : 'Closest matches';
        $('[data-results-summary]').textContent = !picked
          ? products.length + ' designs, each made to order in every size.'
          : exact.length
            ? exact.length + (exact.length === 1 ? ' bed matches' : ' beds match') + ' your choices. All made to order in every size.'
            : 'Nothing ticks every box, so here are the closest designs.';
      }

      function build() {
        exact = products.filter(function (p) { return fits(p); }).sort(function (a, b) { return a.title.localeCompare(b.title); });
        similar = products.filter(function (p) { return !fits(p) && score(p) > 0; })
          .sort(function (a, b) { return (score(b) - score(a)) || a.title.localeCompare(b.title); });
        if (!exact.length && similar.length) mode = 'all';
        render();
      }

      function pills() {
        var box = $('[data-pills]');
        box.replaceChildren();
        GROUPS.forEach(function (g) {
          state[g].forEach(function (v) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'al-finder__pill';
            b.setAttribute('aria-label', 'Remove ' + LABELS[g][v]);
            b.textContent = LABELS[g][v] + '  ×';
            b.addEventListener('click', function () {
              state[g] = state[g].filter(function (x) { return x !== v; });
              setSelected(g, v, false);
              limit = pageSize; mode = 'best';
              pills(); build();
            });
            box.appendChild(b);
          });
        });
      }

      function showResults() {
        root.querySelectorAll('[data-stage]').forEach(function (s) { s.hidden = true; });
        $('[data-stage="results"]').hidden = false;
        progress.style.width = '100%';
        nav.hidden = true;
        updateTabs(-1);
        limit = pageSize; mode = 'best';
        pills(); build();
      }

      function goNext() { if (current === steps.length - 1) showResults(); else showStep(current + 1); }

      root.querySelectorAll('[data-group]').forEach(function (box) {
        box.addEventListener('click', function (e) {
          var b = e.target.closest('[data-value]');
          if (!b || !box.contains(b)) return;
          var g = box.dataset.group, v = b.dataset.value;
          var on = state[g].indexOf(v) > -1;
          state[g] = on ? state[g].filter(function (x) { return x !== v; }) : state[g].concat(v);
          setSelected(g, v, !on);
          refreshOptions(g);
          updateLive();
        });
      });

      tabs.forEach(function (t) { t.addEventListener('click', function () { showStep(parseInt(t.dataset.goto, 10)); }); });
      next.addEventListener('click', goNext);
      skip.addEventListener('click', function () {
        var g = steps[current];
        state[g].forEach(function (v) { setSelected(g, v, false); });
        state[g] = [];
        goNext();
      });
      back.addEventListener('click', function () { showStep(current - 1); });
      $('[data-restart]').addEventListener('click', function () {
        state = { shape: [], finish: [], height: [] };
        root.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
        showStep(0);
      });
      root.querySelectorAll('[data-result-mode]').forEach(function (b) {
        b.addEventListener('click', function () { mode = b.dataset.resultMode; limit = pageSize; render(); });
      });
      more.addEventListener('click', function () { limit += pageSize; render(); });

      showStep(0);
    }

    function initAll() { document.querySelectorAll('.al-finder').forEach(initFinder); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('.al-finder');
      if (r) initFinder(r);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
